<template>
    <section v-if="hasAnswers" class="tp-section">
        <header class="tp-section-head">
            <i class="fal fa-comment-alt-lines tp-section-ic"></i>
            <h3 class="tp-section-title">
                {{ $t('post.page.preview.contribution') }}
            </h3>
        </header>

        <div class="tp-section-body">
            <template v-for="answer in visibleAnswers">
                <component
                    :key="answer.id"
                    :is="answer.name"
                    :value="answer"
                    :post="post"
                />
            </template>
        </div>
    </section>
</template>

<script>
import PreviewLocationAttribute from './Attribute/PreviewLocationAttribute'
import PreviewCategoryAttribute from './Attribute/PreviewCategoryAttribute'
import PreviewClassicAttribute from './Attribute/PreviewClassicAttribute'
import CheckboxAttribute from './Attribute/CheckboxAttribute'

const HIDDEN = ['gdpr', 'file-upload']

export default {
    name: 'PostPreviewAnswers',
    props: ['post'],
    components: {
        location: PreviewLocationAttribute,
        category: PreviewCategoryAttribute,
        smalltext: PreviewClassicAttribute,
        email: PreviewClassicAttribute,
        markdown: PreviewClassicAttribute,
        rating: PreviewClassicAttribute,
        'select-field': PreviewClassicAttribute,
        checkbox: CheckboxAttribute,
        radio: PreviewClassicAttribute,
        date: PreviewClassicAttribute,
        datetime: PreviewClassicAttribute,
        number: PreviewClassicAttribute
    },
    computed: {
        visibleAnswers() {
            const answers = (this.post && this.post.answers) || []
            return answers.filter((a) => !HIDDEN.includes(a.name))
        },
        hasAnswers() {
            return this.visibleAnswers.length > 0
        }
    }
}
</script>

<style scoped>
.tp-section {
    background: var(--v2-surface-0, #fff);
    border: 1px solid var(--v2-border, #e2e8f0);
    border-radius: 12px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    overflow: hidden;
}

.tp-section-head {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    border-bottom: 1px solid var(--v2-border-subtle, #f1f5f9);
    background: var(--v2-surface-1, #f8fafc);
}

.tp-section-ic {
    color: var(--v2-primary, #0891b2);
    font-size: 0.9rem;
}

.tp-section-title {
    margin: 0;
    font-size: 0.8125rem;
    font-weight: 600;
    color: var(--v2-text-1, #0f172a);
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.tp-section-body {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.tp-section-body >>> h6 {
    font-size: 0.7rem !important;
    font-weight: 600 !important;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--v2-text-3, #64748b) !important;
    margin: 0 0 4px !important;
}

.tp-section-body >>> p {
    font-size: 0.875rem;
    color: var(--v2-text-1, #0f172a);
    margin: 0;
    word-break: break-word;
}
</style>
